import { useEffect, useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_VIDEO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/wingman/387f5408-8bb8-4a7b-bf34-8d730934c9be/attachments/83a881a477124d23849359cdeec6b738_orbit-final-v2.mp4";

let cachedUrl = null;

const getEmbedUrl = (url) => {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0`;
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}?autoplay=1`;
  return null;
};

const VideoModal = ({ open, onOpenChange, title, testid = "video-modal" }) => {
  const [videoUrl, setVideoUrl] = useState(cachedUrl || DEFAULT_VIDEO_URL);

  useEffect(() => {
    if (cachedUrl) return;
    axios
      .get(`${API}/settings/public`)
      .then((res) => {
        cachedUrl = res.data.video_url || DEFAULT_VIDEO_URL;
        setVideoUrl(cachedUrl);
      })
      .catch(() => {});
  }, []);

  const embed = getEmbedUrl(videoUrl);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={testid}
        className="max-w-3xl overflow-hidden border-slate-800 bg-[#0A0F1D] p-0 text-white"
      >
        <div className="relative aspect-video w-full overflow-hidden bg-black">
          {open &&
            (embed ? (
              <iframe
                key={embed}
                data-testid={`${testid}-player`}
                src={embed}
                title={title}
                className="h-full w-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : (
              <video
                key={videoUrl}
                data-testid={`${testid}-player`}
                src={videoUrl}
                className="h-full w-full"
                controls
                autoPlay
                playsInline
              />
            ))}
        </div>
        <DialogHeader className="px-6 pb-5 pt-4">
          <DialogTitle className="font-display text-lg font-bold text-white">{title}</DialogTitle>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default VideoModal;
